export const viewTypesData = [
  {
    name: 'ThisWeek',
    label: 'This Week',
    value: 'week',
  },
  {
    name: 'ThisMonth',
    label: 'This Month',
    value: 'month',
  },
  {
    name: 'ThisYear',
    label: 'This Year',
    value: 'year',
  },
  {
    name: 'AllTime',
    label: 'All Time',
    value: 'alltime',
  },
]
export const likeTypesData = [
  {
    name: 'ThisWeek',
    label: 'This Week',
    value: 'week',
  },
  {
    name: 'ThisMonth',
    label: 'This Month',
    value: 'month',
  },
  {
    name: 'ThisYear',
    label: 'This Year',
    value: 'year',
  },
  {
    name: 'AllTime',
    label: 'All Time',
    value: 'alltime',
  },
]
export const popularListTypeData = [
  {
    name: 'All',
    label: 'All',
    value: 'all',
  },
  {
    name: 'Movies',
    label: 'Movies',
    value: 'movies',
  },
  {
    name: 'Persons',
    label: 'Persons',
    value: 'person',
  },
]

export const categoryTypesData = [
  {
    name: 'Views',
    label: 'Views',
    value: 'views',
  },
  {
    name: 'Likes',
    label: 'Likes',
    value: 'likes',
  },
  {
    name: 'date',
    label: 'date',
    value: 'date',
  },
]
export const DateofUpdate = [
  {
    name: 'desc',
    label: 'desc',
    value: 'desc',
  },
  {
    name: 'asc',
    label: 'asc',
    value: 'asc',
  },
]
